import { deepFreeze } from '@mw/helpers';

const FORM_CHANNEL_FIELDS = {
  NAME: 'name',
};

const FormErrorMessages = deepFreeze({
  CHANNEL_NAME_IS_REQUIRED: 'Channel name is required',
  CHANNEL_DUPLICATE_NAME: 'Enter a unique Channel name',
});

export { FORM_CHANNEL_FIELDS, FormErrorMessages };
